/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import { oidcSettings } from "../config/oidcSettings";
import { vuexOidcCreateStoreModule } from "vuex-oidc";
Vue.use(Vuex);
const defaultStore = {};

const store = new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  strict: process.env.NODE_ENV !== "production",
  modules: {
    defaultStore,
    oidcStore: vuexOidcCreateStoreModule(oidcSettings, {
      dispatchEventsOnWindow: true
    })
  }
});

export default store;
